module.exports = __webpack_public_path__ + "static/Sue-Parks-56e8037affc5df4b667e965bd58d6858.png";